module.exports = __webpack_public_path__ + "static/media/hidden.2549c416.png";